import { useSelector } from 'react-redux';

import { getCurrentTab } from '../../selectors/tabs';
import { ETabs } from '../../types/redux/tabs';
import { AgenciesListingContainer } from '../AgenciesListingContainer';
import { RealtorsListingContainer } from '../RealtorsListingContainer';

export function ListingContainer() {
  const currentTab = useSelector(getCurrentTab);
  const isRealtorsList = currentTab === ETabs.Realtors;

  return isRealtorsList ? <RealtorsListingContainer /> : <AgenciesListingContainer />;
}
